module.exports = __webpack_public_path__ + "static/img/IMG_9829_1920x1440.fc1533e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/IMG_9829_1920x1440.jpg
// module id = H/bm
// module chunks = 1